module.exports = __webpack_public_path__ + "img/gi_catdekor.70e53a8d.png";